export default __webpack_public_path__ + "static/media/appstle_subscriptions_logo.4ac785be.png";